.fj{z-index:2;}